"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRoute = void 0;

var _urlParts = require("./url-parts");

const getRoute = {
  mapWithMedia(uid) {
    return `/${_urlParts.appName}/photos/projects/${_urlParts.projectUid}/map/${uid}`;
  },

  photo(uid) {
    return `/${_urlParts.appName}/photos/projects/${_urlParts.projectUid}/photos/${uid}`;
  }

};
exports.getRoute = getRoute;